exports.onRouteUpdate = ({ location }) => {
  if (location.pathname === '/' && window.RDStationForms) {
    new window.RDStationForms(
      'eye-lp-nova-contato-f0583034c5994558699f',
      'UA-64505833-1',
    ).createForm();
  }
};
